/** Stable conversation id for 1:1 chats between two UIDs */
export function directConversationId(uidA, uidB) {
  return ['dm', ...[String(uidA), String(uidB)].sort()].join('_');
}
